import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'kn',
  months: [
    'ಜನವರಿ',
    'ಫೆಬ್ರವರಿ',
    'ಮಾರ್ಚ್',
    'ಏಪ್ರಿಲ್',
    'ಮೇ',
    'ಜೂನ್',
    'ಜುಲೈ',
    'ಆಗಸ್ಟ್',
    'ಸೆಪ್ಟೆಂಬರ್',
    'ಅಕ್ಟೋಬರ್',
    'ನವೆಂಬರ್',
    'ಡಿಸೆಂಬರ್',
  ],
  monthsShort: ['ಜನ', 'ಫೆಬ್ರ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿ', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗ', 'ಸೆಪ್ಟೆಂ', 'ಅಕ್ಟೋ', 'ನವೆಂ', 'ಡಿಸೆಂ'],
  weekdays: ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ'],
  weekdaysMin: ['ಭಾ', 'ಸೋ', 'ಮಂ', 'ಬು', 'ಗು', 'ಶು', 'ಶ'],
  weekdaysShort: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ವರ್ಷದ ಹಿಂದೆ', other: '%s ವರ್ಷಗಳ ಹಿಂದೆ' },
    M: { one: '%s ತಿಂಗಳು ಹಿಂದೆ', other: '%s ತಿಂಗಳುಗಳ ಹಿಂದೆ' },
    w: { one: '%s ವಾರದ ಹಿಂದೆ', other: '%s ವಾರಗಳ ಹಿಂದೆ' },
    d: { one: '%s ದಿನದ ಹಿಂದೆ', other: '%s ದಿನಗಳ ಹಿಂದೆ' },
    h: { one: '%s ಗಂಟೆ ಹಿಂದೆ', other: '%s ಗಂಟೆಗಳ ಹಿಂದೆ' },
    m: { one: '%s ನಿಮಿಷದ ಹಿಂದೆ', other: '%s ನಿಮಿಷಗಳ ಹಿಂದೆ' },
    s: { one: '%s ಸೆಕೆಂಡ್ ಹಿಂದೆ', other: '%s ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ' },
  },
  future: {
    y: { one: '%s ವರ್ಷದಲ್ಲಿ', other: '%s ವರ್ಷಗಳಲ್ಲಿ' },
    M: { one: '%s ತಿಂಗಳಲ್ಲಿ', other: '%s ತಿಂಗಳುಗಳಲ್ಲಿ' },
    w: { one: '%s ವಾರದಲ್ಲಿ', other: '%s ವಾರಗಳಲ್ಲಿ' },
    d: { one: '%s ದಿನದಲ್ಲಿ', other: '%s ದಿನಗಳಲ್ಲಿ' },
    h: { one: '%s ಗಂಟೆಯಲ್ಲಿ', other: '%s ಗಂಟೆಗಳಲ್ಲಿ' },
    m: { one: '%s ನಿಮಿಷದಲ್ಲಿ', other: '%s ನಿಮಿಷಗಳಲ್ಲಿ' },
    s: { one: '%s ಸೆಕೆಂಡ್‌ನಲ್ಲಿ', other: '%s ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ' },
  },
  abbr: {
    y: { one: '%sವ.', other: '%sವ.' },
    M: { one: '%sನಿಮಿ', other: '%sನಿಮಿ' },
    w: { one: '%sವಾರ', other: '%sವಾರ' },
    d: { one: '%sದಿ', other: '%sದಿ' },
    h: { one: '%sಗಂ', other: '%sಗಂ' },
    m: { one: '%sನಿಮಿ', other: '%sನಿಮಿ' },
    s: { one: '%sಸೆ', other: '%sಸೆ' },
  },
  justNow: 'ಈಗ ತಾನೇ',
  yesterday: 'ನಿನ್ನೆ',
  today: 'ಇಂದು',
  tomorrow: 'ನಾಳೆ',
  weekStart: 0,
};
const localeName: LocaleName = 'kn';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
